import { useEffect, useState } from "react";
import { api } from "../../utils/api";
import { expertiseGridClassName } from "../common/expertise/expertiseGrid";
import ExpertiseTile from "../common/expertise/ExpertiseTile";
import Skeleton from "../common/loading/Skeleton";

/** ثابت روی home — مثل تگ expertise قدیم؛ از CMS تگ/کروسل جدا. */
export default function HomeExpertisesSection({ isDesktop }) {
	const [expertises, setExpertises] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		api
			.expertiseList()
			.then((results) => setExpertises(Array.isArray(results) ? results : []))
			.catch(() => setExpertises([]))
			.finally(() => setIsLoading(false));
	}, []);

	if (isLoading) {
		return <Skeleton variant="grid" type="workshop" count={8} />;
	}

	if (expertises.length === 0) {
		return null;
	}

	return (
		<section aria-label="تخصص‌ها">
			<h2 className="mb-5 font-Vazir-800 text-[18px] text-midGray md:text-[20px]">
				تخصص‌ها
			</h2>
			<div className={expertiseGridClassName(isDesktop)}>
				{expertises.map((expertise, index) => (
					<ExpertiseTile
						key={expertise.id}
						expertise={expertise}
						isDesktop={isDesktop}
						index={index}
						to={`/video_clips/?expertise_id=${expertise.id}`}
					/>
				))}
			</div>
		</section>
	);
}
